import styled from "styled-components";
import { Text } from "../common";

export const Container = styled.div<{ widthRem?: number; heigthRem?: number }>`
  display: block;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: #fff;
  width: ${({ widthRem }) => widthRem ? `${widthRem}rem` : "40rem"};
  z-index: 600;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  font-weight: bold;
  border-radius: 10px;

  &::-webkit-scrollbar {
    background: transparent;
    border-radius: 8px;
    width: 0.25rem;
    margin: 1rem;
    height: 0.25rem;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: #98989c;
    border-radius: 0.5rem;
  }

  @media screen and (max-width: 768px) {
    max-width: 60rem;
    bottom: 0;
    top: auto;
    border-radius: 10px 10px 0px 0px;
    animation: animatebottom 0.6s;
    transform: none;
    width: 98%;
    left: 1%;
  }

  @keyframes animatebottom {
    from {
      bottom: -300px;
      opacity: 0;
    }
    to {
      bottom: 0;
      opacity: 1;
    }
  }
`;

export const Header = styled.div<{
  url: string;
  paddingTop?: string;
  minHeight?: string;
}>`
  font-family: OpenSans, Arial, sans-serif;
  background-image: url(${({ url }) => url});
  min-height: ${({ minHeight }) => (minHeight ? minHeight : "25rem")};
  width: 100%;
  border-radius: 10px 10px 0 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: ${({ paddingTop }) => (paddingTop ? paddingTop : "20px")};
  position: relative;
  z-index: 500;
`;

export const Body = styled.div<{ fontSize?: string; marginX?: string, height?: string }>`
  font-family: OpenSans, Arial, sans-serif;
  margin: 20px auto;
  width: 100%;
  color: #000;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : "15pt")};
  font-weight: normal;
  position: relative;
  padding: 0 3rem;
`;

export const PlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.75rem;
`;

export const Footer = styled.div<{
  height?: string;
  justifyContent?: string;
  marginTop?: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  justify-content: ${({ justifyContent }) =>
    justifyContent ? justifyContent : "space-between"};
  height: ${({ height }) => (height ? height : "auto")};
  padding: 2.5rem 3rem;
  padding-top: 0;
`;


export const TextShadow = styled(Text)<{shadow: string}>`
  text-shadow: ${({ shadow }) => shadow};
`;

interface TextTagProps {
  color?: string;
};

export const TextTag = styled(Text)<TextTagProps>`
  border: 1px solid ${({ color }) => color};
  padding: 5px;
  border-radius: .5rem;
`;

export const CardHeader = styled.div`
  background-color: #441D74;
  border-radius: .5rem .5rem 0 0;
  padding-bottom: .4rem;
`;

export const PriceLabel = styled(Text)`
  display: inline-flex;
  flex-direction: column;
  text-align: left;
`;